namespace GeniuzPOS.Product {
    export interface PsSetItemRow {
        Id?: number;
        SetItemCode?: string;
        SetItemName?: string;
        SetItemShortName?: string;
        SetItemUnit?: string;
        SetPrice?: number;
        StartDate?: string;
        FinishDate?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        PsSetItemDtList?: PsSetItemDtRow[];
        SetName?: string;
        CalDtFg?: number;
    }

    export namespace PsSetItemRow {
        export const idProperty = 'SetItemCode';
        export const nameProperty = 'SetName';
        export const localTextPrefix = 'Product.PsSetItem';
        export const lookupKey = 'Product.PsSetItem';

        export function getLookup(): Q.Lookup<PsSetItemRow> {
            return Q.getLookup<PsSetItemRow>('Product.PsSetItem');
        }
        export const deletePermission = '1POSBASE:การจัดชุดสินค้า:Delete';
        export const insertPermission = '1POSBASE:การจัดชุดสินค้า:Modify';
        export const readPermission = '1POSBASE:การจัดชุดสินค้า:View';
        export const updatePermission = '1POSBASE:การจัดชุดสินค้า:Modify';

        export declare const enum Fields {
            Id = "Id",
            SetItemCode = "SetItemCode",
            SetItemName = "SetItemName",
            SetItemShortName = "SetItemShortName",
            SetItemUnit = "SetItemUnit",
            SetPrice = "SetPrice",
            StartDate = "StartDate",
            FinishDate = "FinishDate",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            PsSetItemDtList = "PsSetItemDtList",
            SetName = "SetName",
            CalDtFg = "CalDtFg"
        }
    }
}
